import { formatMoney, formatNumber, unformat } from "accounting-js";

let options = {
  symbol: "$",
  decimal: ",",
  thousand: ".",
  precision: 2,
  format: "%s%v",
};

export const formatMonto = (monto, moneda) => {
  const options = {
    symbol: moneda === "Pesos" ? "AR$" : "US$",
    decimal: ",",
    thousand: ".",
    precision: 2,
    format: "%s%v",
  };
  return formatMoney(monto, options);
};

export const formatM = (number) => formatMoney(number, options);
export const formatMSinCeros = (number) =>
  formatMoney(number, {
    symbol: "$",
    decimal: ",",
    thousand: ".",
    precision: 0,
    format: "%s%v",
  });
export const formatMM = (number) => formatMoney(unformat(number, ","), options);
export const formatMDecimalConPunto = (number) =>
  formatMoney(unformat(number, "."), options);

export const formatN = (number) => formatNumber(number, options);
export const formatNN = (number) =>
  formatNumber(unformat(number, ","), options);
